
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/component-api/Sparkbars",
      function () {
        return require("private-next-pages/component-api/Sparkbars.mdx");
      }
    ]);
  